import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Dialog,
  DialogTitle,
  List,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import React from "react";

type Props = {
  items: Array<{ text: string; onClick(): void }>;
  open: boolean;
  onClose(): void;
};

export const ModalExportCSV = ({ items, open, onClose }: Props) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle color="primary" sx={{ alignSelf: "center" }}>
        Exporter les données
      </DialogTitle>
      <List sx={{ pt: 0 }}>
        {items.map(({ text, onClick }, index) => (
          <ListItem disableGutters key={index}>
            <ListItemButton
              autoFocus
              onClick={() => {
                onClick();
                onClose();
              }}
            >
              <ListItemAvatar>
                <Avatar>
                  <FileDownloadIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};
